"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreApi = void 0;
const axios_1 = __importDefault(require("axios"));
const constants_1 = require("../constants");
const getHeaderForStore = (authData) => {
    const commonHeader = {
        'Content-Type': 'application/json',
    };
    return authData.auth
        ? { ...commonHeader, Authorization: `Bearer ${authData.userToken}` }
        : { ...commonHeader, 'x-unauthorized-id': authData.xUnauthorizedId };
};
class StoreApi {
    static getGamesList({ projectId, locale = '' }) {
        return this.instance
            .get(`/project/${projectId}/items/game?locale=${locale}`)
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getGameBySku({ projectId, itemSku, locale = '' }) {
        return this.instance
            .get(`/project/${projectId}/items/game/sku/${itemSku}?locale=${locale}`)
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getBundlesList({ projectId, locale = '' }, auth) {
        return this.instance
            .get(`/project/${projectId}/items/bundle?locale=${locale}`, {
            headers: getHeaderForStore(auth),
        })
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getBundleBySku({ projectId, itemSku, locale = '' }) {
        return this.instance
            .get(`/project/${projectId}/items/bundle/sku/${itemSku}?locale=${locale}`)
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getVirtualCurrencyList({ projectId, locale = '' }, auth) {
        return this.instance
            .get(`/project/${projectId}/items/virtual_currency?locale=${locale}`, {
            headers: getHeaderForStore(auth),
        })
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getVirtualCurrencyPackage({ projectId, locale = '' }, auth) {
        return this.instance
            .get(`/project/${projectId}/items/virtual_currency/package?locale=${locale}`, { headers: getHeaderForStore(auth) })
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getVirtualCurrencyPackageBySku({ projectId, itemSku, locale = '', }) {
        return this.instance
            .get(`/project/${projectId}/items/virtual_currency/package/sku/${itemSku}?locale=${locale}`)
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getVirtualItems({ projectId, locale = '' }, auth) {
        return this.instance
            .get(`/project/${projectId}/items/virtual_items?locale=${locale}`, { headers: getHeaderForStore(auth) })
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getVirtualItemsByGroup({ projectId, groupId, locale = '' }, auth) {
        return this.instance
            .get(`/project/${projectId}/items/virtual_items/group/${groupId}?locale=${locale}`, { headers: getHeaderForStore(auth) })
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getVirtualItemsGroup({ projectId, locale = '' }) {
        return this.instance
            .get(`/project/${projectId}/items/groups?locale=${locale}`)
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static getVirtualItemBySku({ projectId, itemSku, locale = '', }) {
        return this.instance
            .get(`/project/${projectId}/items/virtual_items/sku/${itemSku}?locale=${locale}`)
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static createTokenByItem({ projectId, itemSku, auth, body, }) {
        return this.instance
            .post(`/project/${projectId}/payment/item/${itemSku}`, { ...body }, { headers: getHeaderForStore(auth) })
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static createTokenByCart({ projectId, cartId, body, auth, xUser, }) {
        return this.instance
            .post(`/project/${projectId}/payment/cart/${cartId}`, body, {
            headers: {
                ...getHeaderForStore(auth),
                'x-user': btoa(JSON.stringify(xUser)),
            },
        })
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
    static createOrderWithFreeItem({ projectId, itemSku, userToken, }) {
        return this.instance
            .post(`/project/${projectId}/free/item/${itemSku}`, {}, {
            headers: getHeaderForStore({ auth: true, userToken }),
        })
            .then((res) => res.data)
            .catch(StoreApi.handleError);
    }
}
exports.StoreApi = StoreApi;
StoreApi.instance = axios_1.default.create({ baseURL: constants_1.STORE_API_URL });
// TODO Move this handler to transformResponse or AxiosAdapter, using the Promise rejection for errors
StoreApi.handleError = (e) => {
    if (e.response) {
        const error = e.response.data;
        return {
            errorCode: error?.errorCode || 0,
            errorMessage: error?.errorMessage || '',
            statusCode: error?.statusCode || 0,
        };
    }
    return {
        errorCode: 0,
        errorMessage: JSON.stringify(e.toString()),
        statusCode: 0,
    };
};
